import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { withRouteData } from 'react-static'

import { catalogSearchParamsAction } from '../connectors/redux/actions'

import SelectPicker from './SelectPicker'
import SvgIcon from './SvgIcon'

const options = [
    { value: 'text', label: 'Text' },
    { value: 'image', label: 'Image' },
    { value: 'speech', label: 'Speech' },
    // { value: 'video', label: 'Video' },
]

class CatalogSearch extends React.Component {
    constructor(props) {
        super(props)
        let contentType = ''
        if (props.pathContentType) {
            // eslint-disable-next-line no-extra-semi
            ;[contentType] = options.filter(
                op => op.value === props.pathContentType
            )
            props.dispatch(catalogSearchParamsAction({ contentType }))
        }
        this.state = {
            search: '',
            contentType,
            // language: '',
            integratedOnly: undefined,
            showFilters: false, // for mobile screens
        }
    }

    render() {
        const {
            placeholder,
            extraLight /* , languages = defaultLanguages */,
        } = this.props

        return (
            <div className="search">
                <form className="search__form">
                    <div
                        className={classnames('search__input', {
                            'search__input--light': extraLight,
                        })}
                    >
                        <div className="search__input-icon">
                            <SvgIcon slug="magnifier" />
                        </div>
                        <input
                            className="search__input-control"
                            type="text"
                            name="search"
                            placeholder={placeholder}
                            value={this.state.search}
                            onChange={this.handleChange}
                        />
                        <div className="search__results">
                            <div className="search__results-item">
                                <mark>senti</mark>ment sentiment
                            </div>
                            <div className="search__results-item">
                                <span className="search__results-chapter">
                                    Intent:
                                </span>{' '}
                                <mark>Senti</mark>ment Analysis
                            </div>
                            <div className="search__results-item">
                                <span className="search__results-chapter">
                                    Provider:
                                </span>{' '}
                                <mark>Senti</mark>lex
                            </div>
                        </div>
                    </div>
                    <div
                        className={classnames('search__filters', {
                            'search__filters--visible': this.state.showFilters,
                        })}
                    >
                        <div className="catalog_search_filter_item search__filters-item search__filters-item--type">
                            <div className="select">
                                <SelectPicker
                                    isClearable
                                    name="contentType"
                                    extraLight={extraLight}
                                    placeholder="Content type"
                                    options={options}
                                    value={this.state.contentType}
                                    onChange={this.handleSelectChange(
                                        'contentType'
                                    )}
                                />
                            </div>
                        </div>
                        {/* <div className="search__filters-item search__filters-item--language">
                            <div className="select">
                                <SelectPicker
                                    name="language"
                                    extraLight={extraLight}
                                    placeholder="Choose language"
                                    options={languages.map(langToOption)}
                                    value={this.state.language}
                                    onChange={this.handleSelectChange(
                                        'language'
                                    )}
                                />
                            </div>
                        </div> */}
                        <div className="search__filters-item search__filters-item--checkbox">
                            <label
                                className={classnames('checkbox', {
                                    'checkbox--white': extraLight,
                                })}
                                htmlFor="integratedOnly"
                            >
                                <input
                                    className="checkbox__control"
                                    type="checkbox"
                                    name="integratedOnly"
                                    value={this.state.integratedOnly}
                                    onChange={this.handleCheckboxChange}
                                    id="integratedOnly"
                                />
                                <span className="checkbox__box">
                                    <SvgIcon slug="tick" />
                                </span>
                                <span className="checkbox__text">
                                    Integrated only
                                </span>
                            </label>
                        </div>
                        {/* <div className="search__filters-item search__filters-item--sort">
                            <div className="select">
                                <span
                                    className="select__label"
                                    htmlFor="quality"
                                >
                                    Sort by:
                                </span>
                                <SelectPicker
                                    id="quality"
                                    name="quality"
                                    extraLight={extraLight}
                                    placeholder="Quality"
                                    options={qualities}
                                    value={this.state.quality}
                                    onChange={this.handleSelectChange(
                                        'quality'
                                    )}
                                />
                            </div>
                        </div> */}
                    </div>
                    <div className="search__toggle-filters">
                        <button
                            className="search__toggle-filters-button button button--white button--outline"
                            type="button"
                            data-default-text="Show filter"
                            data-active-text="Hide filter"
                            onClick={this.handleFilterToggle}
                        >
                            {this.state.showFilters
                                ? 'Hide filter'
                                : 'Show filter'}
                        </button>
                    </div>
                </form>
            </div>
        )
    }

    handleFilterToggle = () => {
        this.setState({
            showFilters: !this.state.showFilters,
        })
    }

    handleChange = event => {
        const params = {
            [event.target.name]: event.target.value,
        }
        this.updateParams(params)
    }

    handleCheckboxChange = event => {
        const params = {
            [event.target.name]: event.target.checked,
        }
        this.updateParams(params)
    }

    handleSelectChange = name => option => {
        const params = {
            [name]: option,
        }
        this.updateParams(params)
    }

    updateParams = params => {
        const { dispatch } = this.props
        this.setState(params, () => {
            dispatch(catalogSearchParamsAction(params))
        })
    }
}

export default connect(() => ({}))(withRouteData(CatalogSearch))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/CatalogSearch.jsx